import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f9d426c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrapper vh-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "パスワード入力", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, "\n            パスワードを入力しましょう\n          ", -1))
const _hoisted_4 = { class: "pb-5 text-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("u", { class: "text-size-14 text-mild" }, "パスワードを忘れた場合", -1))

import { h, ref } from "vue";
import { useRouter } from "vue-router";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import { accountService } from "@/app/services/AccountService";
import { authService } from "@/app/services/AuthService";
import { authStore } from "@/store/auth";
import { orderStore } from "@/store/order";
import { sendAdjustEvent } from "@/plugins/adjust";
import { sendFirebaseCustomEvent } from "@/plugins/firebase";
import ExternalLink from "@/const/externalLink";
import AppButtonOutline from "@/components/atoms/button/AppButtonOutline.vue";
import { captureException } from "@/plugins/sentry";
import { useLoader } from "@/utils/loader";
import { useModal } from "@/utils/modal";
import { AbTest3113 } from "@/app/services/AbTestService";
import { useCustomRouter } from "@/utils/router";
import { onMounted } from "vue";
import PasswordInputGroup from "@/components/molecules/form/PasswordInputGroup.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const resetPasswordBeforeLoginRoute = { name: "ResetPasswordBeforeLogin" };

const modal = useModal();
const loader = useLoader();
const router = useRouter();
const customRouter = useCustomRouter();

const phoneNumber = ref("");
const password = ref("");
const hidePhoneNumber = ref(false);

onMounted(() => {
  // query に phoneNumber が含まれている場合、phoneNumber にセットする
  const phoneNumberQuery = router.currentRoute?.value?.query?.phoneNumber;
  if (phoneNumberQuery) {
    phoneNumber.value = phoneNumberQuery as string;
    hidePhoneNumber.value = true;
  }
  // 簡単にpasswordのinputを取れないのでqueryで取得
  const passwordInput = document.querySelector<HTMLInputElement>(
    "[type='password']"
  );
  if (passwordInput) passwordInput.focus();
});

async function login() {
  try {
    loader.show();

    const { status, isActive } = await requestWorkerLoginStatus();
    authStore.changeWorkerLoginStatus(status);

    // 退会済みユーザーの場合はログイン処理を行わない
    if ((status === "login_user" || status === "v1_user") && !isActive) {
      showInactiveUserModal();
      return;
    }

    // 有効なユーザーの場合のみログイン処理を行う
    const body = {
      password: password.value,
      phoneNumber: phoneNumber.value
    };
    await authService.workerLogin(body);
    orderStore.clearOrderList();
    orderStore.clearEvaluations();
    AbTest3113.registerEvent(AbTest3113.eventTypes.enterPasswordNext);
    sendAdjustEvent("LOGIN");
    sendFirebaseCustomEvent("login", {
      session_id: authStore.sessionId || "unknown"
    });

    try {
      // アプリ起動（未ログイン）からログインした場合、起動に関する情報を記録
      // workerLogin によって authStore.user に認証済みユーザーに関する値が設定される
      const cordova = window.cordova;
      if (cordova && authStore.user) {
        await accountService.recordAppBoot();
      }
      // ODM の初期設定
      authStore.initiateOnDeviceConversionMeasurement();
    } catch (e) {
      // アプリの挙動には影響ないため、エラー通知はするが処理は続行する
      captureException(e as Error);
    }

    await customRouter.pushIgnoreError({ name: "Search" });
  } catch (e) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const err = e as any;
    // phoneNumberが不正な場合
    if (!err.response || !err.response.data) {
      await modal.msgBoxOk("不正な操作です", {
        centered: true
      });
    }

    // 入力内容が正しくない場合
    if (err.response.data.nonFieldErrors) {
      modal.msgBoxOk(err.response.data.nonFieldErrors[0], {
        centered: true
      });
      return;
    }

    await modal.msgBoxOk("不正な操作です", {
      centered: true
    });
  } finally {
    loader.hide();
  }
}

function requestWorkerLoginStatus() {
  const body = {
    phoneNumber: phoneNumber.value
  };
  return authService.requestWorkerLoginStatus(body);
}

function showInactiveUserModal() {
  const messageVNode = h("div", [
    h("p", "一時的に利用停止中のためログインできません。"),
    h("p", "利用停止期間を過ぎましたら、アカウントが復帰されます。"),
    h("p", [
      "アカウントが復帰されない場合は、運営事務局へお問い合わせください。",
      h(
        AppButtonOutline,
        {
          class: "mb-1 mt-3",
          href: ExternalLink.CONTACT,
          size: "small",
          block: true
        },
        "お問い合わせフォーム"
      )
    ])
  ]);
  // bootstrap-vue の型定義は Vue2 のままなので、ここでは型エラーになってしまう
  // @ts-ignore
  modal.msgBoxOk(messageVNode, {
    centered: true
  });
}

function onClickBack() {
  router.back();
}

return (_ctx: any,_cache: any) => {
  const _component_BForm = _resolveComponent("BForm")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, null, {
      left: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "chevron-left",
          onClick: onClickBack
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(),
        _hoisted_2
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createVNode(_component_CustomValidationObserver, {
      ref: "form",
      tag: "div"
    }, {
      default: _withCtx(({ handleSubmit, valid }) => [
        _createVNode(_component_BForm, {
          class: "container",
          onSubmit: _withModifiers(($event: any) => (handleSubmit(login)), ["stop","prevent"])
        }, {
          default: _withCtx(() => [
            _createElementVNode("main", null, [
              _hoisted_3,
              _createTextVNode(),
              _createVNode(PasswordInputGroup, {
                modelValue: password.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
                class: "w-100 password-input",
                "hide-help-text": "",
                "required-only": ""
              }, null, 8, ["modelValue"]),
              _createTextVNode(),
              _createVNode(AppButton, {
                block: "",
                rounded: "",
                class: "next-button",
                onClick: ($event: any) => (handleSubmit(login)),
                disabled: !valid
              }, {
                default: _withCtx(() => [
                  _createTextVNode("\n            次へ\n          ")
                ], undefined, true),
                _: 2
              }, 1032, ["onClick", "disabled"])
            ])
          ], undefined, true),
          _: 2
        }, 1032, ["onSubmit"])
      ]),
      _: 1
    }, 512),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_RouterLink, { to: resetPasswordBeforeLoginRoute }, {
        default: _withCtx(() => [
          _hoisted_5
        ], undefined, true),
        _: 1
      })
    ])
  ]))
}
}

})